import type { ViewProps } from '../../types';
import * as React from 'react';
import { ContactA as ContactComponent } from '../../containers/ContactA';

export function View(props: ViewProps) {
  return (
    <>
      <ContactComponent {...props} />
    </>
  );
}
